module.exports = __webpack_public_path__ + "static/media/alteraCadastro.fcc4cebd.png";